"use client";
import { createContext, useContext } from "react";
import type { ReactNode } from "react";
import { usePatientDetails } from "../queries/usePatientDetails";
import { Patient } from "../types";

interface PatientDetailsContextValue {
  patientId: string | null;
  patient: Patient | undefined;
  isLoading: boolean;
  isError: boolean;
}

const PatientDetailsContext = createContext<PatientDetailsContextValue | null>(
  null,
);

export function PatientDetailsProvider({
  patientId,
  children,
}: {
  patientId: string | null;
  children: ReactNode;
}) {
  const { data: patient, isLoading, isError } = usePatientDetails(patientId);

  return (
    <PatientDetailsContext.Provider
      value={{ patientId, patient: patient as Patient, isLoading, isError }}
    >
      {children}
    </PatientDetailsContext.Provider>
  );
}

export function usePatientDetailsContext() {
  const ctx = useContext(PatientDetailsContext);
  if (!ctx)
    throw new Error(
      "usePatientDetailsContext must be used within PatientDetailsProvider",
    );
  return ctx;
}
